// ReactJs
import React, { useEffect, useState } from 'react'
// Node modules
import styled from 'styled-components'
// Layouts
import PageLayout from '../../components/PageLayout'
import FaqList from './FaqList'
// Services
import { getFaqs, incrementStatistic } from '../../services'

const FaqContainer = styled(PageLayout)`
`

export default function FaqPage({ ...props }) {
  const [faqs, setFaqs] = useState([])

  useEffect(() => {
    const getData = async () => {
      const result = await getFaqs()
      result && setFaqs(result)
    }
    if (!faqs.length) {
      getData()
    }
    incrementStatistic('FAQ_PAGE')
  }, [])

  return (
    <FaqContainer
      title="Foire aux questions"
      prevLink="/"
    >
      { faqs.length > 0 && <FaqList faqs={ faqs }/> }
    </FaqContainer>
  )
}
